import {
  Autocomplete,
  Box,
  Button,
  Card,
  Grid,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import { useFormik } from "formik";
import { useEffect, useState } from "react";
import Service from "services/payables";
import { dotToComma } from "utils/numberComma";
import { exportToExcel } from "react-json-to-excel";
import { format } from "utils/formatDate";
import { findBillingStatus } from "layouts/payables/components/yupSchema";
import { findPrazoPagamento } from "layouts/pedidos-compra/components/contas/yupSchema";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR_DataGrid } from "utils/datagrid";

const initialValues = {
  startDate: "",
  endDate: "",
};

export default function TicketMedio() {
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);
  const [report2, setReport2] = useState(0);

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const { payables, averageTicket } = await Service.averageTicket({
          ...values,
        });

        const payablesParsed = parsePayables(payables);

        if (!payables.length) {
          alert("Nenhum resultado encontrado");
        }

        setReport(payablesParsed);
        setReport2(averageTicket);

        setLoading(false);
      } catch (error) {
        console.log(error);
      }

      setLoading(false);
    },
  });

  const parsePayables = (rows) => {
    const payables = rows.map((row) => {
      return {
        Descrição: row.descricao,
        Fornecedor:
          row.supplier?.nomeFantasia || row.supplier?.razaoSocial || "",
        "Método de Pagamento": row.paymentMethod?.descricao || "",
        "Data do Pedido": row.dataPedido
          ? format(new Date(row.dataPedido), "dd/MM/yyyy")
          : "",
        "Data de Vencimento": row.dataVencimento
          ? format(new Date(row.dataVencimento), "dd/MM/yyyy")
          : "",
        "Data de Pagamento": row.dataPagamento
          ? format(new Date(row.dataPagamento), "dd/MM/yyyy")
          : "",
        Valor: dotToComma(row.valor),
        Situação: findBillingStatus(row.status),
        "Centro de Custo": row.accountGroup?.descricao || "",
        "Natureza de Lançamento": row.accountSubGroup?.descricao || "",
        Prazo: findPrazoPagamento(row.prazoPagamento),
      };
    });

    return payables;
  };

  const printPayables = (payables) => {
    exportToExcel(payables, "ticket_medio_" + new Date().getTime(), true);
  };

  return (
    <DashboardLayout>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white" mt={1}>
                  Relatório de Ticket Médio
                </MDTypography>
              </MDBox>
              <MDBox pt={3} mx={2} py={3} px={2}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 2,
                    mb: 2,
                  }}
                  component="form"
                  onSubmit={formik.handleSubmit}
                >
                  <TextField
                    id="startDate"
                    name="startDate"
                    label="Data Inicial"
                    type="date"
                    value={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.startDate &&
                      Boolean(formik.errors.startDate)
                    }
                    helperText={
                      formik.touched.startDate && formik.errors.startDate
                    }
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <TextField
                    id="endDate"
                    name="endDate"
                    label="Data Final"
                    type="date"
                    value={formik.values.endDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.endDate && Boolean(formik.errors.endDate)
                    }
                    helperText={formik.touched.endDate && formik.errors.endDate}
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{
                      gridColumn: "span 2",
                      justifySelf: "center",
                      width: "100%",
                      color: "white !important",
                    }}
                  >
                    {loading ? "Carregando..." : "Gerar Relatório"}
                  </Button>
                </Box>
              </MDBox>
            </Card>

            {report.length > 0 && (
              <>
                <br />
                <h2 style={{ textAlign: "center" }}>Ticket Médio</h2>
                <h3 style={{ textAlign: "center" }}>
                  {dotToComma(report2.toFixed(2))}
                </h3>

                <Card sx={{ marginTop: 4 }}>
                  <DataGrid
                    initialState={{
                      pagination: { paginationModel: { pageSize: 25 } },
                    }}
                    pageSizeOptions={[25, 100]}
                    rows={report.map((row, index) =>
                      Object({ ...row, id: index })
                    )}
                    columns={Object.keys(report[0]).map((key) =>
                      Object({
                        headerName: key,
                        field: key,
                        flex: Object.keys(report[0]).length / 10,
                      })
                    )}
                    rowCount={report.length}
                    rowSelection={false}
                    localeText={ptBR_DataGrid}
                    sx={{
                      ".MuiDataGrid-virtualScroller": {
                        minHeight: "100px",
                      },
                    }}
                  />
                </Card>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() =>
                      printPayables([
                        {
                          sheetName: "Ticket Médio",
                          details: [{ "Ticket Médio": dotToComma(report2) }],
                        },
                        {
                          sheetName: "Contas à Pagar",
                          details: report,
                        },
                      ])
                    }
                    sx={{
                      color: "white !important",
                    }}
                  >
                    Exportar para Excel
                  </Button>
                </Box>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
